import { UserData } from "../../user/User";
import { AppAction } from "../../root/AppAction";
import PresentersEvents from "./PresentersEvents";
import { combineReducers } from "redux";
import { FilteredUserInfo } from "./models/UserFilter";

export interface PresentersIndexStore {
  isLoading: boolean;
  users?: UserData[];
  filteredUsers?: FilteredUserInfo[];
  skills?: string[];
  tags?: string[];
}

const initialIndexStore: PresentersIndexStore = {
  isLoading: false,
};

export function index(
  state: PresentersIndexStore = initialIndexStore,
  action: AppAction
) {
  switch (action.type) {
    case PresentersEvents.LoadAll:
      return {
        ...state,
        isLoading: true,
        users: undefined,
      };

    case PresentersEvents.LoadAllComplete: {
      return {
        ...state,
        isLoading: false,
        users: action.users,
      };
    }

    case PresentersEvents.filterUserListStarted:
      return {
        ...state,
        isLoading: true,
      };

    case PresentersEvents.filterUserListComplete:
      return {
        ...state,
        isLoading: false,
        filteredUsers: action.filterResult.professionals,
        skills: action.filterResult.skills,
        tags: action.filterResult.tags,
      };

    default:
      return state;
  }
}

export interface PresentersProfileStore {
  isLoading: boolean;
  userInfo?: UserData;
}

const initialProfileStore: PresentersProfileStore = {
  isLoading: false,
};

export function profile(
  state: PresentersProfileStore = initialProfileStore,
  action: AppAction
) {
  switch (action.type) {
    case PresentersEvents.Load:
      return {
        ...state,
        isLoading: true,
        userInfo: undefined,
      };

    case PresentersEvents.LoadComplete:
      return {
        ...state,
        isLoading: false,
        userInfo: action.userInfo,
      };

    default:
      return state;
  }
}

export interface PresentersStore {
  index: PresentersIndexStore;
  profile: PresentersProfileStore;
}

export default combineReducers<PresentersStore>({
  index,
  profile,
});
